import React, { useState, useEffect } from 'react';
import {
    TextField,
    Button,
    List,
    ListItem,
    ListItemText,
    IconButton,
    Typography,
    InputAdornment,
} from '@mui/material';
import { Close } from '@mui/icons-material';

const CompetitionRules = ({ onRulesChange, rules: initialRules, errors = {} }) => {
    const [rules, setRules] = useState(initialRules || []);
    const [currentRule, setCurrentRule] = useState('');
    const [error, setError] = useState('');

    // Update rules when initialRules changes
    useEffect(() => {
        setRules(initialRules || []);
    }, [initialRules]);

    const handleAddRule = () => {
        const trimmedRule = currentRule.trim();
        if (!trimmedRule) return;

        if (rules.some((rule) => rule.toLowerCase() === trimmedRule.toLowerCase())) {
            setError('This rule already exists!');
            return;
        }

        const updatedRules = [...rules, trimmedRule];
        setRules(updatedRules);
        setCurrentRule('');
        setError('');
        onRulesChange(updatedRules);
    };

    const handleDeleteRule = (index) => {
        const updatedRules = rules.filter((_, i) => i !== index);
        setRules(updatedRules);
        setCurrentRule('');
        setError('');
        onRulesChange(updatedRules);
    };

    return (
        <React.Fragment>
            <Typography variant="body1" gutterBottom fontWeight="bold">
                Competition Rules
            </Typography>

            <TextField
                required
                label="Enter Rule"
                placeholder="Type competition rule here..."
                variant="outlined"
                size="small"
                margin="dense"
                fullWidth
                value={currentRule}
                onChange={(e) => setCurrentRule(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleAddRule()}
                sx={{ '& .MuiOutlinedInput-root': { paddingRight: '0 !important' } }}
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position="end">
                                <Button
                                    variant="contained"
                                    onClick={handleAddRule}
                                    disableElevation
                                    sx={{ textTransform: 'none' }}
                                >
                                    Add
                                </Button>
                            </InputAdornment>
                        ),
                    },
                }}
                error={!!errors.competition_rules}
                helperText={errors.competition_rules?.[0] || ''}
            />

            {error && (
                <Typography variant="body2" color="error" sx={{ mt: 0.5 }}>
                    {error}
                </Typography>
            )}

            <List
                disablePadding
                sx={{
                    mt: 1,
                    position: 'relative',
                    overflow: 'auto',
                    maxHeight: 180,
                    border: rules.length > 0 ? '1px dashed grey' : 'none',
                    borderRadius: 1,
                }}>
                {rules.map((rule, index) => (
                    <ListItem
                        key={index}
                        secondaryAction={
                            <IconButton edge="end" onClick={() => handleDeleteRule(index)}>
                                <Close />
                            </IconButton>
                        }
                    >
                        <ListItemText primary={`${index + 1}. ${rule}`} />
                    </ListItem>
                ))}
            </List>
        </React.Fragment>
    );
};

export default CompetitionRules;